export var compKey = 'label-list';
//# sourceMappingURL=key.js.map